module.exports = __webpack_public_path__ + "img/student_photo@2x.388ffbcf.png";